import appHost from '@/utils/app'
export function setStorage<T = any>(key: string, item: T): void {
  try {
    // 原生web存储
    sessionStorage.setItem(key, JSON.stringify(item))
    // app存储
    appHost.setAppStorage(
      JSON.stringify({
        type: key,
        data: item,
      })
    )
  } catch (error) {
    console.log('error', error)
  }
}
